angular.module 'app'
.controller 'FocusOnController', ($scope, $stateParams) ->
  $scope.ui =
    wechat_id: $stateParams.wechat_id